import React, { useEffect, useState } from "react";
import API from "../../api/api";
import "../../style/adminDashboard.css";
import { Link } from "react-router-dom";

export default function AdminDashboard() {

  const [data, setData] = useState({
    stats: {},
    recentUsers: []
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await API.get("/admin/summary");
      setData(res.data);
    } catch (err) {
      console.error("Dashboard load error", err);
    } finally {
      setLoading(false);
    }
  };

  const format = (n) => (n ?? 0).toLocaleString();

  if (loading) {
    return <div className="dashboard-loading">Loading dashboard...</div>;
  }

  const { stats = {}, recentUsers = [] } = data;

  return (
    <div className="dashboard-container">

      <h2 className="dashboard-title">Admin Dashboard</h2>

      {/* ===== STATS ===== */}
      <div className="stats-grid">

  <Link to="/admin/users" className="stat-link">
    <div className="stat-card">
      <h4>Total Users</h4>
      <p>{format(stats.users?.total)}</p>
    </div>
  </Link>

  <Link to="/admin/users" className="stat-link">
    <div className="stat-card">
      <h4>Active Today</h4>
      <p>{format(stats.users?.activeToday)}</p>
    </div>
  </Link>

  <Link to="/admin/users" className="stat-link">
    <div className="stat-card">
      <h4>New (7 Days)</h4>
      <p>{format(stats.users?.newLast7Days)}</p>
    </div>
  </Link>

  <Link to="/admin/payments" className="stat-link">
    <div className="stat-card">
      <h4>Total Revenue</h4>
      <p>₹{format(stats.revenue?.total)}</p>
    </div>
  </Link>

  <Link to="/admin/payments" className="stat-link">
    <div className="stat-card">
      <h4>Revenue Today</h4>
      <p>₹{format(stats.revenue?.today)}</p>
    </div>
  </Link>

  <Link to="/admin/credits" className="stat-link">
    <div className="stat-card">
      <h4>Credits Used</h4>
      <p>{format(stats.credits?.used)}</p>
    </div>
  </Link>

  <Link to="/admin/credits" className="stat-link">
    <div className="stat-card">
      <h4>Credits Purchased</h4>
      <p>{format(stats.credits?.purchased)}</p>
    </div>
  </Link>

  <Link to="/admin/credits" className="stat-link">
    <div className="stat-card">
      <h4>Total Chats</h4>
      <p>{format(stats.engagement?.totalChats)}</p>
    </div>
  </Link>

  <Link to="/admin/credits" className="stat-link">
    <div className="stat-card">
      <h4>Total Messages</h4>
      <p>{format(stats.engagement?.totalMessages)}</p>
    </div>
  </Link>

  <Link to="/admin/analytics" className="stat-link">
    <div className="stat-card">
      <h4>Conversion Rate</h4>
      <p>{stats.conversion?.rate || 0}%</p>
    </div>
  </Link>

  <Link to="/admin/guests" className="stat-link">
    <div className="stat-card">
      <h4>Guests</h4>
      <p>{format(stats.guests?.total)}</p>
    </div>
  </Link>

</div>

      {/* ===== TOP USERS ===== */}
      <div className="section">

        <h3 className="section-title">Top Users (Credits Used)</h3>

        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Credits Used</th>
            </tr>
          </thead>

          <tbody>
            {data.topUsers?.length === 0 ? (
              <tr><td colSpan="3">No data</td></tr>
            ) : (
              data.topUsers?.map(u => (
                <tr key={u.userId}>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{format(u.totalSpent)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

      </div>

      {/* ===== PLAN STATS ===== */}
      <div className="section">

        <h3 className="section-title">Plan Performance</h3>

        <table className="table">
          <thead>
            <tr>
              <th>Plan</th>
              <th>Sales</th>
              <th>Revenue</th>
            </tr>
          </thead>

          <tbody>
            {data.planStats?.length === 0 ? (
              <tr><td colSpan="3">No data</td></tr>
            ) : (
              data.planStats?.map((p, i) => (
                <tr key={i}>
                  <td>{p._id}</td>
                  <td>{p.totalSales}</td>
                  <td>₹{format(p.revenue)}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

      </div>

      {/* ===== RECENT USERS ===== */}
      <div className="section">

        <h3 className="section-title">Recent Users</h3>

        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Credits</th>
              <th>Joined</th>
            </tr>
          </thead>

          <tbody>
            {recentUsers.length === 0 ? (
              <tr><td colSpan="4">No users</td></tr>
            ) : (
              recentUsers.map((u) => (
                <tr key={u._id}>
                  <td>{u.name}</td>
                  <td>{u.email}</td>
                  <td>{format(u.credits)}</td>
                  <td>{new Date(u.createdAt).toLocaleDateString()}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>

      </div>

    </div>
  );
}